import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Mindset from "./Mindset";
import Digital from "./Digital";
import Agile from "./Agile";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mindset" element={<Mindset />} />
        <Route path="/digital" element={<Digital />} />
        <Route path="/agile" element={<Agile />} />
      </Routes>
    </BrowserRouter>
  );
}
